import styled from 'styled-components';

const TabLabel = styled.label`
	color: rgba(var(--base-06), 1);

	svg {
		margin-left: 6px;
	}
`;

export default TabLabel;
